import { Buyer } from '@40seas/entities/buyers';
import { Executor, FromSchema } from '@40seas/entities/common';
import { BaseEntity, WithBaseEntitySchema } from '@40seas/models';
import { z } from 'zod';

export const StripeCustomerSchema = WithBaseEntitySchema(
    z.object({
        buyer: z.string().or(Buyer['schema']),
        providerId: z.string(),
        isMicroDepositEnabled: z.boolean().optional(),
        stripeConnectedAccount: z.string().optional(),
    }),
).strict();

export class StripeCustomer extends FromSchema(StripeCustomerSchema) implements BaseEntity {
    id: string;
    buyer: string | Buyer;
    providerId: string;
    isMicroDepositEnabled?: boolean;
    createdAt: Date;
    updatedAt: Date;
    tenantId: string;
    stripeConnectedAccount?: string;
    seller?: string;
    createdBy: Executor;
    metadata?: { [key: string]: string };
    timeline?: { [status: string]: { updatedAt: Date } };
}

export class MultiTenantStripeCustomer extends StripeCustomer {}
